import { Layout, Text } from '@loadsmart/miranda-react'

import emptyShipperListPage from '../assets/empty-shipper-list-page.png'

export function EmptyShippersListState() {
  return (
    <Layout.Stack gap="spacing-4" align="center">
      <img alt="Empty shipper list" src={emptyShipperListPage} width={320} />
      <Text variant="heading-lg-bold">Looking for a way to book faster?</Text>
      <Text variant="body-lg">
        Connect with shippers and start receiving freight offers right now
      </Text>
    </Layout.Stack>
  )
}
